export default {
      id: "outgoing-call-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#outgoing-call-usage",
      toString: function () {
        return this.url;
      }
    }